import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthenticationService } from './authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {

  constructor(private router: Router, private authenticationService: AuthenticationService) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!this.authenticationService.isLoggedIn()) {
      this.router.navigate(['login']);
      return false;
    }

    const userRoles = this.authenticationService.getRoles();
    const requiredRoles = route.data['roles'] as string[] | undefined;

    if (userRoles.includes(this.authenticationService.ROLE_OL_ADMINISTRATEUR)) {
      return true;
    }

    if (requiredRoles) {
      if (requiredRoles.includes('viewer')) {
        if (this.authenticationService.isViewer()) {
          return true;
        }
      }
    }

    return false;
  }
}
